import { render, staticRenderFns } from "./WaitingCall.vue?vue&type=template&id=5fb9e9ea&"
import script from "./WaitingCall.vue?vue&type=script&lang=js&"
export * from "./WaitingCall.vue?vue&type=script&lang=js&"
import style0 from "./WaitingCall.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports